/** A version of Object.keys that correctly infers the keys of the object being iterated over. */
export const ObjectKeys = <T extends object>(obj: T) =>
  Object.keys(obj) as (keyof T)[];
